import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Users from './pages/Users';
import Booking from './pages/Booking';
import Bookings from './pages/Bookings';
import Submissions from './pages/Submissions';
import Features from './pages/Features';
import MyBookings from './pages/MyBookings'; // ✅ ADD THIS LINE

import './css/style.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App-layout">
        <Navbar />
        <div className="App-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/users" element={<Users />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/bookings" element={<Bookings />} />
            <Route path="/submissions" element={<Submissions />} />
            <Route path="/location-and-amenities" element={<Features />} />
            <Route path="/my-bookings" element={<MyBookings />} /> {/* ✅ ADD THIS LINE */}
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;